module.exports = __webpack_public_path__ + "static/img/ktbzxkh@2x.1af983b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account/ktbzxkh@2x.png
// module id = nkxj
// module chunks = 70